export const CALENDAR_GREGORY = 'gregory'
export const CALENDAR_LONG = 'long'
export const CALENDAR_NARROW = 'narrow'
export const CALENDAR_SHORT = 'short'

export const DATE_FORMAT_2_DIGIT = '2-digit'
export const DATE_FORMAT_NUMERIC = 'numeric'
